import React from 'react';
import { Section } from './ui/Section';
import { Star, Clock, PlusCircle, MinusCircle, Calendar, ShieldCheck } from 'lucide-react';
export function WhatsInside() {
  return <Section data-id="element-190">
      <h2 className="text-3xl md:text-5xl font-bold text-center mb-16 text-primary-dark" data-id="element-191">
        Inside the Smart Supplement Guide, You’ll Discover…
      </h2>

      <div className="space-y-12" data-id="element-192">
        {/* Golden Rules & Timing */}
        <div className="grid md:grid-cols-2 gap-8" data-id="element-193">
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-sage-light/30" data-id="element-194">
            <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-6 text-primary" data-id="element-195">
              <Star size={24} data-id="element-196" />
            </div>
            <h3 className="text-2xl font-serif font-bold mb-4" data-id="element-197">
              The golden rules of supplementation
            </h3>
            <p className="text-charcoal/80" data-id="element-198">
              Learn the foundational principles that help you avoid common
              mistakes from the start.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-sage-light/30" data-id="element-199">
            <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-6 text-primary" data-id="element-200">
              <Clock size={24} data-id="element-201" />
            </div>
            <h3 className="text-2xl font-serif font-bold mb-4" data-id="element-202">
              The best times of day to take popular supplements
            </h3>
            <p className="text-charcoal/80" data-id="element-203">
              Know when to take magnesium, vitamin D, omega-3, zinc,
              multivitamins, and more.
            </p>
          </div>
        </div>

        {/* Synergies & Antagonisms */}
        <div className="grid md:grid-cols-2 gap-8" data-id="element-204">
          <div className="bg-sage/10 p-8 rounded-2xl border border-sage/20" data-id="element-205">
            <div className="flex items-center gap-3 mb-6" data-id="element-206">
              <PlusCircle className="text-primary" size={28} data-id="element-207" />
              <h3 className="text-2xl font-serif font-bold" data-id="element-208">
                Which supplements work better together
              </h3>
            </div>
            <p className="mb-6 text-charcoal/80" data-id="element-209">
              Discover effective synergies like:
            </p>
            <ul className="space-y-3" data-id="element-210">
              {['Vitamin D3 + K2', 'Magnesium + Vitamin D', 'Iron + Vitamin C', 'Turmeric + Black Pepper'].map((item, i) => <li key={i} className="flex items-center gap-3 bg-white px-4 py-3 rounded-lg shadow-sm font-medium" data-id="element-211">
                  <div className="w-2 h-2 rounded-full bg-primary" data-id="element-212"></div>
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-213">
            <div className="flex items-center gap-3 mb-6" data-id="element-214">
              <MinusCircle className="text-red-600" size={28} data-id="element-215" />
              <h3 className="text-2xl font-serif font-bold" data-id="element-216">
                Which supplements should be separated
              </h3>
            </div>
            <p className="mb-6 text-charcoal/80" data-id="element-217">
              Avoid combinations that can reduce absorption or cancel out
              benefits, such as:
            </p>
            <ul className="space-y-3" data-id="element-218">
              {['Calcium + Iron', 'Zinc + Copper', 'Iron + Coffee or Tea'].map((item, i) => <li key={i} className="flex items-center gap-3 bg-white px-4 py-3 rounded-lg shadow-sm font-medium" data-id="element-219">
                    <div className="w-2 h-2 rounded-full bg-red-400" data-id="element-220"></div>
                    {item}
                  </li>)}
            </ul>
          </div>
        </div>

        {/* Routine & Quality */}
        <div className="grid md:grid-cols-2 gap-8" data-id="element-221">
          <div className="bg-white p-8 rounded-2xl shadow-sm border border-sage-light/30" data-id="element-222">
            <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-6 text-primary" data-id="element-223">
              <Calendar size={24} data-id="element-224" />
            </div>
            <h3 className="text-2xl font-serif font-bold mb-4" data-id="element-225">
              A simple daily routine example
            </h3>
            <p className="text-charcoal/80" data-id="element-226">
              See how to organize your supplements from morning to night in a
              way that makes sense.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-sage-light/30" data-id="element-227">
            <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mb-6 text-primary" data-id="element-228">
              <ShieldCheck size={24} data-id="element-229" />
            </div>
            <h3 className="text-2xl font-serif font-bold mb-4" data-id="element-230">
              A supplement quality checklist
            </h3>
            <p className="text-charcoal/80 mb-4" data-id="element-231">
              Learn how to choose better products by looking for:
            </p>
            <ul className="space-y-2 text-sm font-medium text-primary-dark" data-id="element-232">
              <li data-id="element-233">✓ Natural sourcing</li>
              <li data-id="element-234">✓ Organic and Non-GMO ingredients</li>
              <li data-id="element-235">✓ Transparent labels</li>
              <li data-id="element-236">✓ GMP standards or third-party testing</li>
            </ul>
          </div>
        </div>
      </div>
    </Section>;
}